import { RunList } from "./RunList";
import { RunDetail } from "./RunDetail";

export function RunsView({
  run,
  onRunChange,
}: {
  run: string | null;
  onRunChange: (id: string | null) => void;
}) {
  return (
    <div style={{ display: "grid", gap: 24 }}>
      <RunList selectedRun={run} onSelect={(id) => onRunChange(id)} />
      {run ? (
        <RunDetail runId={run} />
      ) : (
        <p style={{ color: "var(--text-dim)", fontSize: "0.85rem" }}>Select a run to inspect it.</p>
      )}
    </div>
  );
}
